var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 10H11",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.75 1.74816C8.94891 1.54925 9.2187 1.4375 9.5 1.4375C9.63929 1.4375 9.77721 1.46493 9.9059 1.51824C10.0346 1.57154 10.1515 1.64967 10.25 1.74816C10.3485 1.84665 10.4266 1.96358 10.4799 2.09226C10.5332 2.22095 10.5607 2.35887 10.5607 2.49816C10.5607 2.63745 10.5332 2.77537 10.4799 2.90406C10.4266 3.03274 10.3485 3.14967 10.25 3.24816L4 9.49816L2 9.99816L2.5 7.99816L8.75 1.74816Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.7caaf377fb77127a64d825274057f0c7.svg";
export { ForwardRef as ReactComponent };